export default {
  infoLabel: 'Información del Componente',
  closeLabel: 'Cerrar información',
  faq: {
    title: '¿Cómo funciona el filtro?',
    description: 'Las categorías se agregan y cada subcategoría se divide a través de los espacios en cada etiqueta',
  },
  faq2: {
    title: '¿Qué se visualiza?',
    description: 'El gráfico muestra solo las etiquetas seleccionadas, cualquier otra etiqueta que no esté seleccionada en el filtro, aunque esté presente en las publicaciones filtradas, no aparecerá en el gráfico',
  },
};
